import React from "react";
import StatisticsView from "../views/StatisticsView";

export function renderStatisticsMenuContent({
    students,
    teachers,
    attendanceLogs,
    finances,
    annualBudget,
    visitLogs,
    selectedDepartment,
    currentTheme,
    isStatsEditMode,
    setIsStatsEditMode,
    isStatsSettingsOpen,
    setIsStatsSettingsOpen,
    setActiveMenu,
    setStudentListType,
    setTargetStudentId,
    targetStatisticsSection,
    setTargetStatisticsSection,
    setDetailReturnMenu
}) {
    const handleOpenStudentDetail = (studentId) => {
        if (!studentId) return;
        setDetailReturnMenu("statistics");
        setStudentListType("student");
        setTargetStudentId(studentId);
        setActiveMenu("students");
    };

    return (
        <StatisticsView
            students={students}
            teachers={teachers}
            attendanceLogs={attendanceLogs}
            finances={finances}
            annualBudget={annualBudget}
            visitLogs={visitLogs}
            selectedDepartment={selectedDepartment}
            theme={currentTheme}
            isEditMode={isStatsEditMode}
            onToggleEditMode={setIsStatsEditMode}
            isSettingsOpen={isStatsSettingsOpen}
            onCloseSettings={() => setIsStatsSettingsOpen(false)}
            onToggleSettings={() => setIsStatsSettingsOpen((prev) => !prev)}
            onOpenStudentDetail={handleOpenStudentDetail}
            targetSection={targetStatisticsSection}
            onConsumeTargetSection={() => setTargetStatisticsSection(null)}
        />
    );
}
